import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import '@fontsource/rubik';

export default function QuickTurnRulesCard() {
  return (
    <Box
      sx={{
        backgroundColor: '#d6f7e0',
        border: '1px solid #b6ecc6',
        borderRadius: '14px',
        p: '16px 18px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
        <InfoOutlinedIcon sx={{ fontSize: 16, color: '#00a836' }} />
        <Typography
          sx={{
            fontFamily: 'Rubik',
            fontSize: { xs: '12px', lg: '13px', xl: '14px' },
            fontWeight: 700,
            color: '#08231B',
          }}
        >
          24-hr Quick Turn Rules
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: 'Rubik',
          fontSize: { xs: '11px', lg: '12px', xl: '13px' },
          lineHeight: 1.55,
          color: '#282831',
        }}
      >
        <strong style={{ fontWeight: 600, color: '#08231B' }}>Heads up:</strong> Schedule at least{' '}
        <strong style={{ fontWeight: 600, color: '#08231B' }}>1 week in advance</strong>. Turnaround
        is based on business days.
      </Typography>
    </Box>
  );
}
